var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2AccountSubscriptionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4585 4.83325H49.5418C50.5085 4.83325 51.3543 5.19575 52.0793 5.92075C52.8043 6.64575 53.1668 7.49159 53.1668 8.45825V37.4583C53.1668 38.4249 52.8043 39.2708 52.0793 39.9958C51.3543 40.7208 50.5085 41.0833 49.5418 41.0833H37.821V53.1666L29.0002 48.6958L20.1793 53.1666V41.0833H8.4585C7.49183 41.0833 6.646 40.7208 5.921 39.9958C5.196 39.2708 4.8335 38.4249 4.8335 37.4583V8.45825C4.8335 7.49159 5.196 6.64575 5.921 5.92075C6.646 5.19575 7.49183 4.83325 8.4585 4.83325ZM8.4585 31.2353H49.5418V24.7103H8.4585V31.2353Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2AccountSubscriptionWhite);
export default __webpack_public_path__ + "static/media/v2-account-subscription-white.89b1330653f01c963eceec9e85695417.svg";
export { ForwardRef as ReactComponent };